import { createApp } from 'vue'

import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { useFeatureStore } from '@/stores/features'
import { useLanguageStore } from '@/stores/language'
import { $api } from '@/utils/api'
import { getI18n } from '@/plugins/i18n'
import { initClientErrorReporter } from '@/utils/clientErrorReporter'

// Styles
import '@core-scss/template/index.scss'
import '@styles/styles.scss'

if (typeof window !== 'undefined') {
  initClientErrorReporter('tenant-spa')

  window.addEventListener('vite:preloadError', event => {
    const payload = (event as Event & { payload?: unknown }).payload
    const message = payload instanceof Error ? payload.message : String(payload ?? '')
    const hasChunkLoadFailure = message.includes('Failed to fetch dynamically imported module')
      || message.includes('Unable to preload CSS')

    if (!hasChunkLoadFailure)
      return

    // Avoid infinite reload loops if the new document still cannot load the same asset.
    const reloadKey = 'vite:preload-error-reload-at'
    const now = Date.now()

    try {
      const lastReloadAt = Number(sessionStorage.getItem(reloadKey) || 0)
      if (lastReloadAt && now - lastReloadAt < 15000)
        return

      sessionStorage.setItem(reloadKey, String(now))
    }
    catch {
      return
    }

    event.preventDefault()
    window.location.reload()
  })
}

// Create vue app
const app = createApp(App)

// Register plugins
registerPlugins(app)

// Mount vue app after resolving tenant context from /api/user
;(async () => {
  // Carica tenant e features SOLO dopo che l'access token è presente
  try {
    const token = useCookie('accessToken').value
    if (token) {
      const user = await $api<any>('/user')
      setUserDataCookie(user)
      const tid = user?.tenant?.id
      if (tid) {
        try { localStorage.setItem('tenantId', String(tid)) }
        catch {}
      }

      await useFeatureStore().load()

      // Load translations
      await useLanguageStore().fetchTranslations(getI18n().global.locale.value)
    }
  }
  catch {}

  app.mount('#app')

  // Hide initial Blade loader overlay once Vue app is mounted
  if (typeof document !== 'undefined') {
    const loaderBg = document.getElementById('loading-bg')
    if (loaderBg)
      loaderBg.style.display = 'none'
  }
})()
